import React from 'react';
import ZNetwork from "./znetwork";
import ZProps from "./zprops";
import ZLog from "./zlog";
import ZUtil from "./zutil";
import ZAPI from "./zapi";
import AMC from "./AMC";
import {ZOO} from "./zoo";
import {APP} from "./App";
import AMCConstants from "./AMCConstants";
import {ROUTER} from "./AMCRouter";
import PleaseStandBy from "./PleaseStandBy";
import ZooNothingFoundPage from "./ZooNothingFoundPage";
import ZooKudosButton from "./ZooKudosButton";
import ZooLikesButton from "./ZooLikesButton";
import ZooStarsButton from "./ZooStarsButton";
import ZooShareMenu from "./ZooShareMenu";
import FreakoutButton from "./FreakoutButton";
import ZComments from "./zcomments";
import ZooErrorFoundPage from "./ZooErrorFoundPage";
import ZooNoResultsFound from "./ZooNoResultsFound";
import { MainMenuItem } from './zoo';
import AMCStripeCheckoutButton from './AMCStripeCheckout';
import AMCTransactionsManagerFactory from './AMCTransactions';
import AMCGraph from './AMCGraph';
import { ZooSearchResultLineItem } from "./ZooLeaderboardsPage";
import AMCCloneButton from './AMCCloneButton';
import RockstarEditor, { RockSanityCheck } from './rs';
import RockWorkspace from "./RockWorkspace";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faBatteryFull, faBatteryEmpty, faBatteryHalf, faBatteryQuarter, faBatteryThreeQuarters, faPhoneAlt, faCheck, faBan, faEllipsisV, faExpand, faChevronDown, faBug, faPlay, faShare, faThumbsUp, faStar, faCogs, faUsers, faExternalLinkAlt, faLink, faClone, faPuzzlePiece } from '@fortawesome/free-solid-svg-icons';
import LICENSES from "./licenses";
import RockPanel from "./RockPanel";

export default class ZooProfilePage extends React.Component {
	constructor(props) {
		super(props);
		this.state = { expanded: ZOO.isExpanded() };
	}
	componentDidMount() {
		this.getBundle(this.props.item_uri);
		ZProps.set("pagename", "Zoo profile");
		this.listener = ZProps.addListener("ninja", (name, value, oldvalue) => {
			switch (value) {
				case "expand" :
					this.toggleExpand(true);
					break;
				default:
					break;
			}
		});
		let parms = ZProps.get("queryparms");
		this.setState({ view: parms && parms.view });
	}
	componentWillUnmount() {
		ZProps.removeListener(this.listener);
		APP.setTitle(null);
		if (this.service_state_subscription) {
			ZAPI.unsubscribe(this.service_state_subscription);
		}
	}
	// need owner, can't just get from ZProps
	getBundle(item_uri) {
		AMC.getBundle(item_uri, (err, thing) => {
			if (err || !thing) {
				ZLog.error("Zoo did not find item: " + item_uri);
				this.setState({notfound: true});
			} else {
//thing.version = 0;
//AMC.update(thing);
				APP.setTitle(thing.name);
				// AMC.activity(thing, "visit");
				this.setState({ item: thing });
				if (thing.kind === "service") {
					this.onServiceLoad(thing);
				}
			}
		});
	}
	toggleExpand(flag) {
		let to_expand = flag !== false && (flag === true || !this.state.expanded);
		this.setState({ expanded: to_expand, view: null });
		ZProps.set("queryparms", null);
		ROUTER.softPushRoute("/zoo/" + this.state.item.uri);
		ZOO.onExpand(to_expand);
	}
	showItemProfile = (thing) => {
		ZLog.debug("ZooProfilePage.showItemProfile=" + thing.uri);
		if (thing.kind === "service") {
			ROUTER.softPushRoute("/zoo/" + thing.uri);
			this.getBundle(thing.uri);
		} else {
			let group = ZProps.get(thing.group);
			if (!group) {
				AMC.getUser(thing.group, (err, user) => {
					this.setState({ item: thing });
					ROUTER.softPushRoute("/zoo/" + thing.uri);
				});
			} else {
				this.setState({ item: thing });
/*
				if (thing.kind === "service") {
					this.onServiceLoad(thing);
				}
*/
				ROUTER.softPushRoute("/zoo/" + thing.uri);
			}
			// AMC.activity(thing, "visit");
		}
	}
	onServiceLoad(service) {
		if (this.service_state_subscription) {
			//ZAPI.unsubscribe(this.model_state_subscription);
			ZAPI.unsubscribe(this.service_state_subscription);
		}
		this.service_state_subscription = ZAPI.subscribe(service.uri + "/feed", (topic, payload) => {
			ZLog.debug("Rockstar received realtime service feed: ", { payload: payload });
			if (payload.name === "state") {
				if (payload.state.endsWith("ed")) {
					service[payload.state] = true;
				}
				service.state = payload.state;
/*
gets out of sync with deployed version
				let model = AMC.getModel(service)
				if (payload.state !== "deployed" && payload.state.endsWith("ed")) {
					model[payload.state] = true;
					model.state = payload.state;
				}
*/
				if (AMC.isEditable(service)) {
					// called even when no changes made - e.g. each 'predicted'
					AMC.update(service);
				}
				this.setState({ item: service });
			} else if (payload.name === "stats") {
				//let model = AMC.getModel(service)
				//Object.assign(model, payload.stats);
				service.stats = service.stats || {};
				Object.assign(service.stats, payload.stats);
				if (AMC.isEditable(service)) {
					AMC.update(service);
				}
			// DEPRECATED
/*
			} else if (payload.name === "usage") {
				let group = ZProps.get("usergroup");
				group.capacity = payload.capacity;
				ZProps.set("usergroup", group);
*/
			} else if (payload.name === "log" && payload.level === "error") {
				service.error = { error: payload.message };
				service.state = "error";
				if (AMC.isEditable(service)) {
					AMC.update(service, (err) => {
						this.setState({ starting_new_runtime: false });
					});
				}
			}
		});
	}
	onMethod = (op, options, callback) => {
		let { item } = this.state;
		if (op === "speed" && item.kind === "service") {
			let { id } = options;
			AMC.update(item.uri, { compute: id || null }, err => {
				if (err) {
					APP.setError("Unable to update service compute - " + err);
				}
				this.setState({ item: ZProps.get(item.uri) });
				this.forceUpdate();
			});
		}
	}
	render() {
		let { item, expanded, view } = this.state;
		if (item) {
			let is_app = item.kind === "service";
			if (expanded) {
				return (
					is_app ? 
					<ZooRockstar key={item.uri} item={item} onMethod={this.onMethod} pp={this} toggleExpand={this.toggleExpand.bind(this)} expanded={expanded} view={view} />
					:
					<ZooMiniRockstar key={item.uri} item={item} pp={this} toggleExpand={this.toggleExpand.bind(this)} expanded={expanded} onWorkspaceItemSelect={this.showItemProfile} view={view} />
				)
			}
			return (
				<div>
					<div className="ZooPageProfileContainer" id="zoopageprofilecontainer">
						{ is_app ? 
						<ZooRockstar key={"rockstar" + item.uri} item={item} onMethod={this.onMethod} pp={this} toggleExpand={this.toggleExpand.bind(this)} expanded={expanded} view={view} />
						: 
						<ZooMiniRockstar key={"minirockstar" + item.uri} item={item} pp={this} toggleExpand={this.toggleExpand.bind(this)} expanded={expanded} view={view} /> 
						}
						<ZooProfilePageContents key={"profile" + item.uri} item={item} />
					</div>
					<ZooSideBar item={item} showsearch={false} showItemProfile={this.showItemProfile} />
				</div>
			)
		} else if (this.state.notfound) {
			return <ZooNothingFoundPage />
		} else {
			return <PleaseStandBy />
		}
	}
	componentDidUpdate() {
		let c = document.getElementById("zoopageprofilecontainer");
		if (c && c.offsetWidth / document.body.offsetWidth < 0.35) {
			c.style.fontSize = "0.5em";
			c.style.marginRight = "50em"; // kludge
		} else if (c) {
			c.style.fontSize = "1em";
			c.style.marginRight = "25em"; // kludge
		}
	}
			
}









export class ZooRockstar extends React.Component {
	constructor(props) {
		super(props);
		this.state = { nav_width: "20%", expanded: this.props.expanded };
		this.ops = { train: "train", retrain: "train", test: "test", retest: "test", deploy: "deploy", redeploy: "deploy", stop: "stop" };
	}
	componentDidMount() {
		let { item, view } = this.props;
		this.listener = ZProps.addListener("ninja", (name, value, oldvalue) => {
			ZLog.debug("ZooRockstar set ninja rockstar: " + value);
			switch (value) {
				case "rockstar" :
					if (!this.state.rockstar_open) {
						this.toggleMode("rockstar");
					}
					break;
				case "rockpile" :
					if (!this.state.rockpile_open) {
						this.toggleMode("rockpile");
					}
					break;
				default:
					break;
			}
		});
		switch (view) {
			case "profile" :
				this.props.toggleExpand(false);
				this.play();
				break;
			case "play" :
				this.props.toggleExpand(true);
				this.play();
				break;
			case "inspect" :
				this.setState({ rockpile_open: false });
				this.toggleMode("rockstar", true);
				this.toggleMode("rockpile", false);
				break;
			case "edit" :
				this.toggleMode("rockstar", true);
				this.toggleMode("rockpile", true);
				break;
			default :
				break;
		}
				
		if (ZUtil.getCandy("rockstar")) {
			let cookie = JSON.parse(ZUtil.getCandy("rockstar"));
			this.setState({ 
				selected_panel: cookie.selected_panel, 
				selected_button: cookie.selected_button, 
				player_open: cookie.player_open, 
				rockstar_open: cookie.rockstar_open, 
				rockpile_open: cookie.rockpile_open, 
				inspector_open: cookie.inspector_open, 
				workspace_open: cookie.workspace_open, 
				nav_width: cookie.nav_width || "20%", 
//				modes: Object.assign(cookie.modes || {}, this.state.modes, { expanded: this.props.expanded })
			});
			if (item.kind === "service" && cookie.rockstar_open) {
				this.prepareRockstar();
			}
		}
	}
	// prepareRockstar
	prepareRockstar() {
		let { item } = this.props;
		this.updateRockIOPortPositions(AMC.getFlattenedService(item), true);
		this.graphman = new AMCGraph(item); 
		this.transman = this.graphman.getTransman();
	}
	componentWillUnmount() {
		if (this.listener) {
			ZProps.removeListener(this.listener);
		}
		if (this.service_state_subscription) {
			ZAPI.unsubscribe(this.service_state_subscription);
			//ZAPI.unsubscribe(this.model_state_subscription);
		}
//		APP.unregisterAcceleratorKeys(this.accel_keys);
		if (this.resizer) {
			this.resizer.disable();
		}
	}
	_updateCandies(state) {
//		state.nav_width = ZProps.get("nav_width");
		let s = {};
		if (document.getElementById("rockstar-navigator")) {
			s.nav_width = document.getElementById("rockstar-navigator").offsetWidth;
		}
		s.selected_panel = this.state.selected_panel;
		s.selected_button = this.state.selected_button;
		s.player_open = this.state.player_open;
		s.rockstar_open = this.state.rockstar_open;
		s.rockpile_open = this.state.rockpile_open;
		s.workspace_open = this.state.workspace_open;
		s.inspector_open = this.state.inspector_open;
		s.modes = this.state.modes; // DEPRECATED
		s = Object.assign(s, state);
		ZUtil.setCandy("rockstar", JSON.stringify(s));
	}
	deselectAll() {
		ZLog.debug("deselectAll");
		if (this.editor) {
			this.editor.deselectAll();
		}
	}
	highlightItem(item_uri) {
		ZLog.debug("HIGHlightElement: " + item_uri);
		if (this.editor) {
			this.editor.highlightItem(item_uri);
		}
	}
	dehighlightItem(item_uri) {
		ZLog.debug("dehighlightItem");
		if (this.editor) {
			this.controller.dehighlightItem(item_uri);
		}
	}
	useSetting(item) {
		if (item) {
			AMC.useSetting(item, (err) => {});
		}
	}
	areYouSure(msg, yes_function) {
		this.setState({ push_panel: this.state.selected_panel, selected_panel: "areyousure", areyousure: yes_function, areyousuremsg: msg });
	}
	theyAreSure(flag, event) {
		if (flag) {
			this.state.areyousure(event);
		}
		this.setState({ panel: this.state.push_panel, areyousure: null, areyousuremsg: null});
	}
	deleteItem(item_uri) {
		ZLog.debug("deleteItem" + item_uri);
		if (item_uri) {
			this.areYouSure("Are you sure you want to delete " + ZProps.get(item_uri).name + "?", () => {
				let id = this.transman.startTransaction("user deleted node");
				this.transman.destroyPart(item_uri);
				this.transman.endTransaction(id);
			});
		}
	}
	selectItem(item) {
		if (item && typeof item === "string") {
			item = ZProps.get(item);
		}
		ZLog.debug("selectPart", { part: item });
		this.setState({ selected_part: item, selected_panel: this.state.selected_button ? "edit" : this.state.selected_panel, selected_button: null });
	}
	newPlaceholder(item) {
		ZLog.debug("newPlaceholder", { item: item });
		let placeholder = { kind: "placeholder", type: null, name: "placeholder", uri: "placeholder-" + Date.now() };
		ZProps.set(placeholder.uri, placeholder);
		this.graphman.insertNewPart(item.uri, placeholder.uri, false);
		this.forceUpdate();
	}
	toggleMode(which, flag) {
		ZLog.debug("toggleMode: " + which);
		let s = this.state;
		let to_open = flag !== false && (flag === true || !s[which + "_open"]);
		s[which + "_open"] = to_open;
		if (which === "rockstar" && to_open) {
ZLog.debug("toggleMode -  rockstar turns off player");
			s.workspace_open = false;
			s.player_open = false;
			if (typeof s.rockpile_open === "undefined") {
				s.rockpile_open = true;
			}
		} else if (which === "player" && to_open) {
ZLog.debug("toggleMode - player turns off rockpile");
			s.rockstar_open = false;
			s.workspace_open = false;
			s.rockpile_open = false;
		} else if (which === "workspace" && to_open) {
			s.rockstar_open = true;
			s.player_open = false;
			s.rockpile_open = false;
		} else if (which === "rockpile" && to_open) {
			s.player_open = false;
			s.workspace_open = false;
		}
		this._updateCandies(s);
		if (which === "rockstar" && to_open) {
			this.prepareRockstar();
		}
ZLog.debug("toggleMode - s=", { s: s });
		this.setState(s);
	}
	onRockstarClose = () => {
ZLog.debug("onRockstarClose");
		this.setState({ rockstar_open: false });
		this._updateCandies({ rockstar_open: false });
	}
/*
	toggleRuntimeState(purpose) {
		if (["training", "testing", "production"].indexOf(this.state.runtime.state || "unknown") !== -1) {
			this.onOperation("stop");
		} else {
			if (purpose === "production") {
				this.onOperation("deploy");
			} else {
				this.onOperation(purpose);
			}
		}
	}
*/
	onOperation = (oper) => {
		ZLog.debug("onOperation", {op: oper});
		let { item } = this.props;
		if (oper === "player" || oper === "compute") {
			return this.togglePanel(oper);
		}
		if (oper === "saved") {
			return this.setSaved();
		}
		if (oper === "publishmodel") {
			let model = AMC.getModel(item);
			if (item.trained && !model.published) {
				ZNetwork.post("publish", "model", { uri: item.uri }, (err) => {

				});
			}
			return;
		}
		let op = this.ops[oper];
		if (op === "train" || op === "test" || op === "deploy" || op === "stop") {
			let errors = RockSanityCheck.validate(item);
			if (errors.length > 0) {
				return this.setState({ validation_errors: errors });
			}
			this.setState({ focus: op, starting_new_runtime: op + "-" + Date.now(), validation_errors: null });
			let model = AMC.getModel(item);
			item.error = null;
			switch (op) {
				case  "train" :
					item.trained = false;
					item.tested = false;
					item.deployed = false;
					item.state = "training";
// legacy fix
delete model.trained;
delete model.state;
delete model.tested;
					//model.trained = false;
					//model.tested = false;
					//model.state = "training";
					break;
				case  "test" :
					item.tested = false;
					item.state = "testing";
					//model.state = "testing";
					//model.tested = false;
					break;
				case  "deploy" :
					item.deployed = false;
					item.state = "deploying";
					item.errors = null;
					item.errors_updated_at = null;
					break;
				case  "stop" :
					item.deployed = false;
					item.state = "stopping";
					break;
				default:
					ZLog.error("Unknown operation op=" + op);
					break;
			
			}
			delete item.error;
ZLog.debug("Before calling API saving service: ", {op: op, service: item.uri});
			ZAPI.invoke("diff", item.uri, {}, (err, result) => {
				item.checksum = result.checksum;
				AMC.save(item, err => {
			//this._saveNewVersionIfNecessary(item, op, (err, item, versioned_uri) => {
ZLog.debug("Calling API invoking service: ", {op: op, service: item.uri});
				ZAPI.clearLogs(item.uri);
				ZAPI.invoke(op, item.uri, {}, (err, result) => {
ZLog.debug("Returning from API: ", {op: op, err: err, result: result, state: item.state});
					if (err || (result && (result.level === "error" || result.errno))) {
						// if not a 410 capacity error or expired token...
						if (result.status >= 500) {
							item.error = result || { level: "error", message: err + "" };
							item.error.purpose = op;
							item.state = "error";
						}
						APP.setError(result.message || (err + ""));
						//let props = { error: result || { error: err + "" }, state: "error" };
						//AMC.update(item.uri, props, (err) => {
						AMC.update(item, () => {
							this.setState({ starting_new_runtime: false });
						});
					} else {
						// ZAPI.clearIsOutOfDate(item.uri);
						AMC.clearIsOutOfDate(item.uri);
						this.setState({ starting_new_runtime: false });
					}
				});
			});
			});
		} else {
			ZLog.error("Unknown operation: " + oper);
		}
	}
/*
	_saveNewVersionIfNecessary(service, op, callback) {
		if (op !== "train") {
			AMC.save(service, err => callback(err, service, service.uri));
		} else {
			AMC.fork(service, (err, versioned_uri) => callback(err, ZProps.get(service.uri), versioned_uri));
		}
	}
*/
	togglePanel = (which, force) => {
		if (!which) {
			return;
		}
		if (this.ops[which]) {
			return this.onOperation(which);
		}
		if (which === "expand") {
			this.props.toggleExpand();
		} else if (which === "play") {
			// this is to let inspector be open during player...
			if (!this.state.player_open && this.state.rockstar_open) {
				let s = { player_open: true, rockpile_open: false, workspace_open: false };
				this._updateCandies(s);
				this.setState(s);
			} else {
				this.toggleMode("player");
			}
		} else if (which === "rockpile" || which === "rockstar" || which === "player" || which === "workspace") {
			this.toggleMode(which);
		} else if (which === "compute") {
			APP.showPopup(<ZooComputeUpgrades caller={this} />);
		} else {
			let panel = (force !== true && this.state.selected_panel === which) ? null : which;
			this.setState({ selected_panel: panel, selected_button: null });
			this._updateCandies({ selected_panel: panel });
		}
	}
	play = () => {
		this._updateCandies({ player_open: true });
		this.setState({ player_open: true });
	}		
	saveType(item_uri, callback) {
		AMC.save(item_uri, (err) => {
			if (!err) {
				this.setState({ saved: Date.now() });
			}
			if (callback) {
				callback(err);
			}
		});
	}
	setSaved = () => {
		this.setState({ saved: Date.now() });
	}
	updateRockIOPortPositions(nodes, refresh) {
		if (refresh) {
			this.io_port_positions = { glue: 0 };
			this.next_io_port_position = 1;
		}
		nodes.forEach( n => {
			n = n.type ? ZProps.get(n.type) : n;
			if (n) {
ZLog.debug("updateRockIOPortPositions node=" + n.uri, { inputs: n.inputs, outputs: n.outputs, node: n });
				(n.inputs || []).concat(n.outputs || []).sort().forEach(io => {
					let name = io.split(":")[0];
					if (this.io_port_positions[name] == null) {
						this.io_port_positions[name] = this.next_io_port_position;
						this.next_io_port_position += 1;
					}
				});
			}
		});
		ZProps.set("rock_io_port_positions", this.io_port_positions);
ZLog.debug("rock_io_port_positions=" , {  io_port_positions:  this.io_port_positions });

	}

//	onBayChange(which) {
//		this.setState({ navbay: which });
//	}
	render() {
		let { item, pp, onMethod } = this.props;
		let { selected_part, selected_panel, lifecycle, starting_new_runtime, player_open, saved, validation_errors } = this.state;
		//let panel = selected_panel;
		let target = selected_part || item;
		let { rockpile_open, rockstar_open, workspace_open } = this.state;
		let modes = Object.assign({}, this.state);
		let transman = this.transman;
console.log("rokstar saved:" + saved);
		return (
			<div className="ZooRockstar">
				<div className="ZooPageProfileArea">
				<div className="ZooPageProfilePanelArea">
					{ rockstar_open ? 
						<RockstarEditor key={starting_new_runtime} service={target} updateRockIOPortPositions={this.updateRockIOPortPositions.bind(this)} graphman={this.graphman} transman={transman} nav_open={rockpile_open && item.kind === "service" && rockstar_open} workspace_open={workspace_open} onOperation={this.onOperation} setService={pp.showItemProfile} onMethod={onMethod} validation_errors={validation_errors} starting_new_runtime={starting_new_runtime} onRockstarClose={this.onRockstarClose} player={player_open ? <div className="ZooPageProfileFeature" data-hint="player" id="rockstar-player"><ZooServiceUI key={player_open} service={target} playing={player_open} play={this.play} /></div> : null} />
					:
					( target.kind === "service" ? 
						<div className="ZooPageProfileFeature" data-hint="player">
							<ZooServiceUI key={player_open} service={target} playing={player_open} play={this.play} />
						</div>
					: 
						<div className="ZooPageProfileFeature">
							<ZooComponentUI item={target} />
						</div>
					)}
				</div>
				</div>
				<ZooRockstarControls item={item} rockstar_open={rockstar_open} lifecycle={lifecycle} part={selected_part} panel={selected_panel} modes={modes} togglePanel={this.togglePanel} player_open={!rockstar_open || player_open} onOperation={this.onOperation} saved={saved} />
			{ starting_new_runtime ? <PleaseStandBy /> : '' }
			</div>
		)

	}
}
class ZooRockstarControls extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	onClone = (target) => {
		AMC.clone(target.uri, function(err, newmodel_uri) {
			if (!err) {
				ROUTER.pushRoute("/zoo/" + newmodel_uri);
			}
		});
	}
	togglePanel = (which) => {
		this.props.togglePanel(which);
	}
	clearSavedMessage() {
		this.forceUpdate();
	}
	onMadeDefault = (target) => {
		AMC.useSetting(target);
	}
	render() {
		let { panel, item, part, modes, rockstar_open, player_open, saved } = this.props;
		let me = ZProps.get("user");
		let target = part || item;
		let is_owner = me.group === target.group;
		let is_app = item.kind === "service";
		let leftsidebuttons = [];
		let ownerthumb = AMC.getUserOrGroupThumbElement(item.owner);
		//let playlabel;
		let DURATION_OF_SAVED_MSG = 2000;
		let show_saved_msg = Date.now() - saved < DURATION_OF_SAVED_MSG;
		if (show_saved_msg) {
ZLog.debug("ZooRockstarControls.player_open: "+ player_open);
			setTimeout(this.clearSavedMessage.bind(this), DURATION_OF_SAVED_MSG - (Date.now() - saved));
		}
		
		modes = modes || {};

		let buttondefs = (item.kind === "service") ? 
			[ 
			modes.rockstar_open ?
				{ panel: "play", label: <span className="ZooPageProfilePlayButton ZToolTip ZToolTipTop" data-tooltip="Start the web app for this service"><FontAwesomeIcon icon={faPlay} /></span>, disabled: item.permissions !== "public" && me.group !== item.group, selected: player_open ? " ZooRockstarControlStateSelected" : "" } 
			: '',

			]
			// not a service
			: is_owner ? // && !rockstar_open ?
			[ 
				show_saved_msg ? { panel: "", label: "Saved...", icon: faCheck, selected: "ZooPageProfileSavedMsg" } : { panel: "", label: "Owner", icon: faCheck, selected: "ZooPageProfileOwner" },
			] 
			: !is_owner && rockstar_open ?
			[
				{ panel: "", label: <span className="ZooPageProfileNotOwner ZToolTip ZToolTipTop" data-tooltip={"Clone and edit copy of this " + target.kind} onClick={e => this.onClone(target)}><FontAwesomeIcon icon={faBan} /> Not owner</span> },
			]
			:
			[]

		let middlebuttons = [
			<span data-hint="compute" key="compute" className={(panel === "compute" ? "ZooRockstarControlsSelected" : "") + (modes["compute"] ? " ZooRockstarControlStateSelected" : "")}><ZooProfileButton item={item} label={<ZooProfilePageComputeBatteryButton />} onClick={e => this.togglePanel("compute")} /> </span>
		];
		if (is_owner) {
			if (show_saved_msg) {
				middlebuttons.push(
					<span key="saved" className="ZooPageProfileSavedMsg ZooPageProfileAppOwner"><ZooProfileButton item={item} label="Saved..." icon={faCheck} /> </span>
				);
			}
		} else if (ZOO.isExpanded()) {
			middlebuttons.push( <span key="notowner"><ZooProfileButton item={item} label={<span data-hint="owner" className="ZooPageProfileAppOwner ZToolTip ZToolTipTop" data-tooltip={"Visit owner's profile page"}><a href={"/" + item.owner} onClick={e => ROUTER.pushRoute("/" + item.owner)}>{ownerthumb} {item.owner} </a> </span>} icon={null} /></span> );
		}


		if (["wtf", "freakout", "helpmechoose", "rockpile"].indexOf(target.kind) !== -1) {
				let btn = null;
				if (AMC.getSettingURI(target.kind) === target.uri) {
					btn = { panel: "", label: <span className="ZooPageProfileDefaultHelp ZToolTip ZToolTipTop" data-tooltip={"This is your default " + target.kind}><FontAwesomeIcon icon={faCheck} /> Default </span> };
				} else {
					btn = { panel: "", label: <span className="ZooPageProfileDefaultHelp ZToolTip ZToolTipTop" data-tooltip={"Set this as the default " + target.kind} onClick={e => this.onMadeDefault(target)}>Make default</span> };
				}
				buttondefs.splice(1, 0, btn);
			}
		if (rockstar_open && is_app) {
			buttondefs.unshift({ panel: "rockpile", label: " ", icon: faPuzzlePiece, tooltip: "The Rockpile palette of components"  });
		}
		if (rockstar_open) {
			buttondefs.unshift({ panel: "workspace", label: " ", icon: faEllipsisV, tooltip: "Your workspace for this service and more"  });
		}

		leftsidebuttons = buttondefs.map( (b, index) => {
			return <span data-hint={b.panel} key={b.panel + index} data-tooltip={b.tooltip} className={(b.tooltip ? "ZToolTip ZToolTipTop " : "") + (b.selected || "") + (modes[b.panel + "_open"] ? " ZooRockstarControlStateSelected" : "")}><ZooProfileButton item={item} label={b.label || (typeof b.label === "string" ? null : b.panel)} icon={b.icon} disabled={b.disabled} onClick={e => this.togglePanel(b.panel)} /> </span> 
		} );
		let rightside_buttondefs = [];
		rightside_buttondefs.push( { panel: "rockstar", label: "", img: "/images/rs.png", tooltip: is_owner ? "Edit this in the Rockstar IDE" : "Inspect this in the Rockstar IDE" } );
		rightside_buttondefs.push( { panel: "expand", label: "", icon: faExpand, tooltip: "Toggle fullscreen / smallscreen" } );
		let rightsiders = rightside_buttondefs.map( b => {
			return <span data-hint={b.panel} key={b.panel} title={b.panel} data-tooltip={b.tooltip} className={(b.tooltip ? "ZToolTip ZToolTipTop" : "") + (panel === b.panel ? " ZooRockstarControlsSelected" : "") + (modes[b.panel + "_open"] || (ZOO.isExpanded() && b.panel === "expand") ? " ZooRockstarControlStateSelected" : "")}><ZooProfileButton item={target} label={b.label || (typeof b.label === "string" ? null : b.panel)} icon={b.icon} img={b.img} onClick={e => this.togglePanel(b.panel)} /> </span> 
		} );
		return ( 
			
				<div className="ZooPageProfileControls ClearFix">
					<div className="ZooPageProfileControlsContent">
						<span className="ZooPageProfileControlsLeftside">
							{leftsidebuttons}
						</span>
						<span className="ZooPageProfileControlsMiddle">
							{middlebuttons}
						</span>
						<span className="ZooPageProfileControlsRightside">
							{rightsiders}
						</span>
					</div>
				</div>
		)
	}
}

/*
class ZooProfilePageSavedMessage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		let { saved } = this.props;
		let DURATION_OF_SAVED_MSG = 1000;
		let show_saved_msg = Date.now() - saved < DURATION_OF_SAVED_MSG;
		if (show_saved_msg) {
			setTimeout(this.clearSavedMessage

	}
	render() {
	}
}
*/

export class ZooProfilePageComputeBatteryButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		this.listener = ZProps.addListener("usergroup",  (name, value, oldvalue) => {
			this.forceUpdate();
		});
	}
	componentWillUnmount() {
		ZProps.removeListener(this.listener);
	}
	render() {
		let group = ZProps.get("usergroup");
		let BATTERIES = [faBatteryEmpty, faBatteryQuarter, faBatteryHalf, faBatteryThreeQuarters, faBatteryFull];
		let MAX = 2;
		switch (group.plan) {
			case "premium" :
				MAX = 100;
				break;
			case "pro" :
				MAX = 3000;
				break;
			case "rockstar" :
				MAX = 10000;
				break;
			case "business" :
				MAX = 10000;
				break;
			default:
				MAX = 2;
				break;
		}
		let battery = BATTERIES[Math.min(Math.floor(Math.max(0, (group.capacity || 0) + (group.battery || 0))/MAX * 5), 4)];
// <FontAwesomeIcon icon={battery} />
		// TODO AMC to save capacities per plan and show warning when below 10% or 1 whichever is larger
		let total = AMC.getCapacity(group);
		return (
			<span className="ZooPageProfilePlayButton ZToolTip ZToolTipTop" data-tooltip={"Compute: " + (group.compute || 1) + "<br/>Capacity: " + ZUtil.decimalPlaces(total, 2) + "<br/><span style='color:#0cf'>(click to upgrade)</span>"}><FontAwesomeIcon icon={battery} /> {group.compute || 1} / <span className={total < 1.5 ? "ZooProfilePageComputeBatteryButtonWarning" : ""}>{ZUtil.toShortFloat(total)}</span></span>
		)
	}
}

export class ZooProfilePageContents extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	toggleBottomPanel(which) {
		this.setState({bottompanel: this.state.bottompanel === which ? null : which});
	}
	render() {
		var p = this.props;
		let { item } = this.props;
		let { bottompanel } = this.state;
		//var user = ZProps.get("user");
		//var editable = AMC.isEditable(item); 
		let license = item.license || LICENSES[0][0];
		let license_link = null;
		for (let i = 0; i < LICENSES.length; ++i) {
			if (LICENSES[i][0] === license) {
				license_link = LICENSES[i][1];
			}
		}
		license = "(" + license.split("(")[1];
		if (bottompanel === "link") {
			let ui = item.nodes.find( x => x.kind === "ui" );
			let apikey = ZProps.get("user").apikey;
			var url = ZUtil.getDataServer() + "/html/" + ui.type + ".html?service_uri=" + encodeURIComponent(item.uri) + "&api_token=" +  encodeURIComponent(apikey) + "&refresh=" + item.updated_at;
		}
		return (
			<div>
				<div className="ZooPageProfile">
					<ZooPageProfileHeader item={item} bottompanel={bottompanel} toggleBottomPanel={this.toggleBottomPanel.bind(this)} />
					{ bottompanel === "share" ?
						<div className="ClearFix ZooPageProfileShareMenu">
							<ZooShareMenu title={item.name} />
						</div>
					: '' }
					{ bottompanel === "api" ?
						<div className="ClearFix ZooPageProfileShareMenu">
							<div className="ZooPageProfileShareMenuContent">
									<code>{AMC.getAPI(item)}</code>
							</div>
						</div>
					: '' }
					{ bottompanel === "link" ?
						<div className="ClearFix ZooPageProfileShareMenu">
							<div className="ZooPageProfileShareMenuContent CENTERED">
								<a target="_blank" href={url}>{url}</a>
								<br/><br/><p className="WARNING">This URL uses your API token - so please keep it private</p>
							</div>
						</div>
					: '' }
					{ bottompanel === "cloneof" ?
						<div className="ClearFix ZooPageProfileShareMenu">
							<div className="ZooPageProfileShareMenuContent CENTERED">
								<a href={"/zoo/" + item.cloned}>{item.cloned}</a>
							</div>
						</div>
					: '' }
					{ bottompanel === "parts" ?
						<div className="ClearFix ZooPageProfilePartsList">
							<ZooEmbeddedSearchResults key={"partslist"} item={item} kind="partslist" />
						</div>
					: '' }
					{ bottompanel === "usedby" ?
						<div className="ClearFix ZooPageProfilePartsList">
							<h1>Used by the following services</h1>
							<ZooEmbeddedSearchResults key={"usedby"} item={item} kind="usedby" />
						</div>
					: '' }
					<div className="ZooPageProfileDescriptionArea">
						<div className="ZooPageProfileTags">
						<FreakoutButton item={item} />
							{ (item.tags || "").split(",").map( t => {
								t = t.trim();
								return t.length === 0 ? '' : <a key={t} href={"/tag/" + t} onClick={ROUTER.pushRoute.bind(ROUTER, "/tag/" + t)}>#{t}</a>
							}) }
						</div>
						<div className="ZooPageProfileDetails">
							<span className="ZooPageProfileDetailsKind">{item.kind}</span>
							<strong>{new Date(item.updated_at || Date.now()).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })}</strong>
							<span className="ZooPageProfileDetailsPermissions">{AMC.getPermissionsThumbElement(item)} {item.permissions}</span>
							{ item.permissions !== "private" ? <span className="ZooPageProfileDetailsPermissions"><a href={license_link} target="_blank">{license} <FontAwesomeIcon icon={faExternalLinkAlt} /></a></span> : '' }
						</div>
						<p className="ZooPageProfileDescription">{item.description || "No description"}</p>
					</div>
					<div className="ZooPageProfileAreaBelow">
						<div className="ZooPageProfileComment ClearFix">
							<ZComments thing_uri={item.uri} />
						</div>
						{ this.state.comments ? 
							<div className="ZooPageProfileComments">
								<ZooPageProfileComments item={p} />
							</div>
						: '' }
					</div>
				</div>
			</div>
		)
	}
}

class ZooPageProfileHeader extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	onCloneApp() {
		AMC.clone(this.props.item.uri, function(err, newmodel_uri) {
			if (!err) {
				ROUTER.pushRoute(AMCConstants.FACTORYURI + "/" + newmodel_uri);
			}
		});
	}
	onGotData() {
		AMC.clone(this.props.item.uri, function(err, newmodel_uri) {
			if (!err) {
				ROUTER.pushRoute(AMCConstants.GOTDATA_URI + "/" + newmodel_uri);
			}
		});
	}
	like() {
		AMC.relate(this.props.item.uri, "like", (err, stats) => {
			this.forceUpdate();
		});
	}
	dislike() {
		AMC.relate(this.props.item.uri, "dislike", (err, stats) => {
			this.forceUpdate();
		});
	}
	toggleBottomPanel(which) {
		this.props.toggleBottomPanel(which);
	}
	toggleAPIMenu() {
		this.setState({apimenu: !this.state.apimenu});
	}
	togglePlaylistMenu() {
		this.setState({playlistmenu: !this.state.playlistmenu});
	}
	render() {
		let { item, bottompanel } = this.props;
ZLog.debug("ZooPageProfileHeader item", { item: item});
		let owner = ZProps.get(item.group || item.owner) || { name: item.group, uri: item.group }; 
		let thumb = AMC.getNodeThumbElement(item);
//		let history_with_thing = ZProps.get(item.uri + ".history_with_thing") || {};
		let ownerthumb = AMC.getUserOrGroupThumbElement(owner.uri);
		return ( 
			<div className="ZooPageProfileHeader">
				<div className="ZooPageProfileTitleHeader ClearFix">
					<span className={"ZooPageProfileItemThumb" + (item.thumb ? "" : " ZooPageProfileItemThumbDefault")}>{thumb}</span>
					<h2 className="ZooPageProfileTitle" data-hint="title">{item.title || item.name || item.uri.split("/")[2]} <span className="ZooPageProfileTitleVisited"><strong>{item.visits || 0}</strong> Visits</span></h2>
				</div>
				<div className="ZooPageProfileTitleStats">
					<div className="ZooPageProfileTitleStatsTop ClearFix">
						<div className="ZooPageProfileTitleStatsTopRight">
{/*
							{ user.plan !== "guest" && user.plan !== "member" ?
								<span>
								<CloneButton uri={item.uri} clones={item.clones} onClone={this.onCloneComponent.bind(this)} />
								<StarButton uri={item.uri} votes={item.votes} />
								</span>
							: '' }
*/}
							<ZooStarsButton item={item} /> 
							<AMCCloneButton item={item} link="/zoo/" />
						</div>
						<div className="ZooPageProfileTitleStatsTopLeft">
							<span className={"ZooPageProfileAvatar" + (owner.avatar || owner.uri === "automatic.ai" ? "" : " ZooPageProfileAvatarDefault")}><a href={"/" + item.owner} onClick={e => ROUTER.pushRoute("/" + item.owner)}>{ownerthumb}</a></span>
							<ZooKudosButton user={owner} />
							<span className="ZooPageProfileOwnerName">{owner.name}</span>
						</div>
					</div>
				</div>
				<div className="ZooPageProfileCommands ClearFix">
					<div className="ZooPageProfileCommandsContent">
						<span data-hint="share" className={"" + (bottompanel === "share" ? " BUTTON_SELECTED_COLOR" : "")}><ZooProfileButton item={item} label="Share" icon={faShare} onClick={this.toggleBottomPanel.bind(this, "share")} /> </span>
						{ item.kind === "service" ?
							<span data-hint="service api" className={"" + (bottompanel === "api" ? " BUTTON_SELECTED_COLOR" : "")}><ZooProfileButton item={item} label="API" icon={faPhoneAlt} onClick={this.toggleBottomPanel.bind(this, "api")} /> </span>
						: '' }
						{ item.kind === "service" ?
							<span data-hint="standalone link" className={"" + (bottompanel === "link" ? " BUTTON_SELECTED_COLOR" : "")}><ZooProfileButton item={item} label="Link" icon={faLink} onClick={this.toggleBottomPanel.bind(this, "link")} /> </span>
						: '' }
						{ item.cloned ?
							<span data-hint="clone of" className={"" + (bottompanel === "cloneof" ? " BUTTON_SELECTED_COLOR" : "")}><ZooProfileButton item={item} label="Cloned" icon={faClone} onClick={this.toggleBottomPanel.bind(this, "cloneof")} /> </span>
						: '' }
						{ item.kind === "service" ?
							<span data-hint="parts list" className={"" + (bottompanel === "parts" ? " BUTTON_SELECTED_COLOR" : "")}><ZooProfileButton item={item} label="Parts" icon={faCogs} onClick={this.toggleBottomPanel.bind(this, "parts")} /> </span>
						: 
							<span data-hint="users" className={"" + (bottompanel === "usedby" ? " BUTTON_SELECTED_COLOR" : "")}><ZooProfileButton item={item} label="Users" icon={faUsers} onClick={this.toggleBottomPanel.bind(this, "usedby")} /> </span>
						}
					<span className="ZooPageProfileThumbs">
						<ZooLikesButton item={item} which="like" />
						<ZooLikesButton item={item} which="dislike" />
					</span>
					</div>
				</div>
				
			</div>
		)
	}
}
export class ZooProfileButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	onClick(command, e) {
		let { disabled } = this.props;
		e.preventDefault();
		if (!disabled) {
			this.props.onClick(command);
		}
	}
	render() {
		let { label, command, icon, img, disabled } = this.props;
		return (
			<span className={"ZooProfileButton" + (disabled ? " ZooProfileButtonDisabled" : "")} onClick={this.onClick.bind(this, command)}><span className="ZooProfileButtonIcon">{icon ? <FontAwesomeIcon icon={icon} /> : <img src={img} alt={command} /> }</span>
				{ label ? <span className="ZooProfileButtonLabel">{label}</span> : '' }
			</span>
		);
	}
}
export class ZooSideBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		let { item } = this.props;
		var self = this;
			AMC.best(item.kind, null, (err, list) => {
				if (list.length < 2) {
					ZNetwork.get("search", "is:service " + item.uri, (err, morelist) => {
						this.setState({ items: list.concat((morelist && morelist.services) || []) });
					})
				} else {
					self.setState({ items: list });
				}
			});
	}
	onSearchKey(id, event) {
		var field = document.getElementById(id);
		if (field.value.length > 0) {
			this.closeCategoryMenu();
		} else {
			this.openCategoryMenu();
		}
	}
	closeSidebar() {
		this.props.close();
	}
	closeCategoryMenu() {

	}
	openCategoryMenu() {

	}
	showItemProfile(item, update_url) {
		this.props.showItemProfile(item, update_url);
	}
	showItemProfileAndUpdateURL(item) {

	}
	closeProfile() {
		this.props.closeProfile();
	}
	doSearch() {
	}
	toggleSearch() {
		this.setState({searching: !this.state.searching});
	}
	render() {
		var p = this.props;
		let { withpartsbar } = this.props;
		var item = p.item;
		var items = this.state.items || [];
		var widgets = [];
		for (var i = 0; i < items.length; ++i) {
			widgets.push(<ZooPageSidebarWidget key={items[i].uri} item={items[i]} zoo={this.props.zoo} update_url={false} hidden={item && items[i].uri === item.uri} showItemProfile={this.showItemProfile.bind(this)} />);
		}
		ZProps.set(AMCConstants.ZOO_SIDEBAR_STATE, { items: items, item: item, view: p.view });

		var searchbar = this.props.showsearch ?
			<div>
				<div className="WZooPageSidebarSearchFieldContainer" >
					<input type="text" id="zoopage_search_field" className="WZooPageSearchField"  onKeyUp={this.onSearchKey.bind(this, "zoopage_search_field")} placeholder="Search..." />
				</div>
{/* 				<img className="WZooPageSidebarCloseButton" onClick={this.closeSidebar.bind(this)} src="/images/closec.png" /> */}
			</div>
			: '';
		return (
			<div className={"ZooPageSidebar" + (withpartsbar ? " ZooPageSidebarWithPartsBar" : "")}>
				{searchbar}
				<div className="ZooPageSidebarContent">
					{widgets}
				</div>
			</div>
		)
	}
}
export class ZooPageSidebarWidget extends React.Component {
	showItemProfile = (item, event) => {
		event.preventDefault();
		this.props.showItemProfile(this.props.item, this.props.update_url);
		//ZUtil.eatEvent(event);
	}
	render() {
		var item = this.props.item;
		var dnd_id = ZUtil.idify(item.uri) + "__";
		var id = "zooPageSidebarWidget" + ZUtil.idify(item.uri);
		var thumb = AMC.getNodeThumb(item);
		var ownerthumb = AMC.getUserOrGroupThumbElement(item.group || "?");
		return(
			<a href={"/zoo/" + item.uri} className={"ZooPageSidebarWidget DragAndDropable " + (this.props.selected ? " ZooPageSidebarWidgetSelected" : "") + (this.props.hidden ? " ZooPageSidebarWidgetHidden" : "")} id={id} data-uri={item.uri} onClick={(e) => this.showItemProfile(item, e)} data-dnd-element-id={dnd_id}>
				<div className="ZooPageSidebarWidgetBunting">
				<div className="ZooPageSidebarWidgetThumb">
					{ typeof thumb === "string" ? <img src={thumb} alt={item.title} /> : thumb }
				</div>
				<div className="ZooPageSidebarWidgetBody">
					<h3>{item.name}</h3>
					<div className="ZooPageSidebarWidgetStats">
						<div className="ZooSidebarWidgetOwnerThumb">{ownerthumb}</div>
						<div>
							<h4>{item.kind}</h4> : <h4 className="ZooPageSidebarWidgetStatsAuthor">{item.group}</h4>
						</div>
{/*						<span className="ZooPageSidebarWidgetRuns Runs"><span className="ZooStatsNumber">{item.runs || 0}</span> runs</span> */}
						<span className="ZooSidebarWidgetStats"><FontAwesomeIcon icon={faStar} /><strong>{item.stars || 0}</strong></span> 
						<span className="ZooSidebarWidgetStats"><FontAwesomeIcon icon={faThumbsUp} /><strong>{item.likes || 0}</strong></span> 
					</div>
				</div>
				</div>
			</a>
		);
	}
}
class ZooPageProfileComments extends React.Component {
	render() {
		return <div>Not implemented</div>
	}
}
export class ZooDebugConsole extends React.Component {
	constructor(props) {
		super(props);
		this.atbottom = true;
		this.state = { focus: this.props.focus || "train", target_log: "log" };
	}
	componentDidMount() {
		let { service } = this.props;
		this.subscription = ZAPI.subscribe(service.uri + "/feed", (topic, payload) => {
			if (payload.name === "log") {
				ZProps.set(service.uri + ".logs", (ZProps.get(service.uri + ".logs") || []).concat([payload]));
				this.forceUpdate();
			}
		});
		ZAPI.getLogs(service, true, (err, list) => {
			this.forceUpdate();
		});
/*
		let logs = ZProps.get(service.uri + ".logs");
		if (logs) {
			this.setState({ logs: logs });
		} else {
console.error("ZooDebugConsole invoke logs");
			ZAPI.invoke("logs", service.uri, { topic: "log" }, (err, list) => {
				let logs = Array.isArray(list) ? list : list ? [list] : [{ timestamp: Date.now(), message: "No logs found" }];
				ZProps.set(service.uri + ".logs", logs);
				this.setState({ logs: logs });
			});
		}
*/
	}
	componentWillUnmount() {
		ZAPI.unsubscribe(this.subscription);
	}
	onTargetOperationChange(operation) {
		this.setState({ focus: operation });
	}
	toggleFilter(log) {
		this.setState({ filter: this.state.filter === log ? null : log});
	}
	onSearch(search) {
		this.setState({ search: search });
	}
	onScroll(e) {
		var HYSTERESIS = 30;
		this.atbottom = Math.abs(e.target.offsetHeight + e.target.scrollTop - e.target.scrollHeight) < HYSTERESIS;
	}
	scrollToBottom() {
		if (this.atbottom) {
			let scrollable = document.getElementById("debug_console_content")
			if (scrollable) {
				scrollable.scrollTop = scrollable.scrollHeight;
			}
		}
	}
	toggleTerminalLogs = () => {
		let show = !this.state.show_terminal_logs;
		if (!show) {
			return this.setState({show_terminal_logs: false });
		}
		let { service } = this.props;
		let PAGESIZE = 100;
		let page = 0;
		ZAPI.invoke("servicelogs", service.uri, { pagesize: PAGESIZE, page: page }, (err, list) => {
			if (err) {
				list = [list];
			}
			list = list || [];
			list = list.slice(0, 200);
			list.forEach( log => log.name = "log" );
			list.reverse();
			ZProps.set(service.uri + ".terminallogs", list);
			return this.setState({show_terminal_logs: true });
		});
	}
	render() {
		let { service } = this.props;
		let { show_terminal_logs } = this.state;
		let { filter, search } = this.state;
		let logs = show_terminal_logs ? ZProps.get(service.uri + ".terminallogs") : ZProps.get(service.uri + ".logs");
		if (!logs) {
			return <PleaseStandBy />;
		}
		for (let i = logs.length - 1; i >= 0; --i) {
			if (logs[i].message === "clear") {
//ZLog.debug("ZooDebugConsole - clear message - clearing previous logs");
				logs = logs.slice(i + 1);
				break;
			}
		}
		logs = logs.filter( log => log.name === "log" );
		let errors = logs.filter( log => log.level === "error" );
		let warnings = logs.filter( log => log.level === "warning" );
		let payload = [];
		let simplelines = false; // true;
		switch (filter) {
			default :
				// falls through
			case "log" :
				logs = logs || [];
				simplelines = false;
				break;
			case "errors" :
				logs = errors;
				simplelines = false;
				break;
			case "warnings" :
				logs = warnings;
				simplelines = false;
				break;
/*
			case "deployer log" :
				logs = logs.debug.deployer || "";
				break;
			case "service log" :
				logs = logs.debug.service || "";
				break;
					<ZooOptionMenu options={["train", "test", "production"]} label={focus} onClick={this.onTargetOperationChange.bind(this)} />
					<ZooOptionMenu options={["log", "errors", "deployer log", "service log"]} label={target_log} onClick={this.onTargetLogChange.bind(this)} />
*/
		}
		if (simplelines) {
			logs = logs.split("\n");
			if (search) {
				logs = logs.filter( line => line.indexOf(search) !== -1 );
			}
			payload = logs.map( (line, index) => <div className={"RockInspectorConsoleLine ClearFix " + (line.indexOf("error") !== -1 ? " RockInspectorConsoleLineError" : (line.indexOf("warning") !== -1 ? " RockInspectorConsoleLineWarning" : ""))}>{index}. {line}</div> );
		} else {
			if (search) {
				logs = logs.filter( line => line.message.indexOf(search) !== -1 );
			}
			// remove duplicates that appear one after the other. 
			// This happens when an error is 1st reported and then returned from a service
			let last_line = null;
			for (let i = 0; i < logs.length; ++i) {
				if (logs[i].message === last_line) {
					logs.splice(i, 1);
					--i;
				} else {
					last_line = logs[i].message;
				}
			}
			payload = logs.map( (line, linenum) => { 
				return (
					<div key={"console" + linenum} className={"RockInspectorConsoleLine ClearFix " + (line.level === "error" ? " RockInspectorConsoleLineError" : (line.level === "warning" ? " RockInspectorConsoleLineWarning" : ""))}>
						<span className="RealtimeCountdown" data-countdown-zero-hour={line.timestamp}>{ZUtil.toShortDate(line.timestamp)}</span>
						{
						typeof line.message === "string" && line.message.indexOf("\n") !== -1 ? line.message.split("\n").map((str, index) => <div key={index + ":" + linenum} className={"IndentSpaces" + (str.length - str.trim().length)}>{str}</div>) 
						: 
						JSON.stringify(line.message)
						}
						<span className="RockInspectorConsoleLineLocation">{line.at}</span>
					</div> 
				)});
		}
		payload.unshift(<div key="version" className="RockInspectorConsoleLine ClearFix">Rockstar v. {AMCConstants.ROCKSTAR_VERSION} console</div>);
				
		return (
			<div className="ZooDebugConsole">
				<div className="ZooDebugConsoleHeader">
					<span className={"ZooDebugConsoleHeaderButton" + (show_terminal_logs ? " ZooDebugConsoleHeaderSelected": "")} onClick={this.toggleTerminalLogs}><FontAwesomeIcon icon={faBug} />Logs</span>
					{ errors.length > 0 ? <span className="ZooDebugConsoleHeaderErrors" onClick={e => this.toggleFilter("errors")}>{ errors.length } errors</span> : '' }
					{warnings.length > 0 ? <span className="ZooDebugConsoleHeaderWarnings" onClick={e => this.toggleFilter("warnings")}>{ warnings.length } warnings</span> : '' }
				</div>
				<div className="ZooDebugConsoleContent" id="debug_console_content" onScroll={this.onScroll.bind(this)}>
					{ payload }
				</div>
				<ZooSearchBar onSearch={this.onSearch.bind(this)} />
			</div>
		)
	}
	componentDidUpdate() {
		this.scrollToBottom();
	}
}
export class ZooSearchBar extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	onSearchKey = (e) => {
		if (e.key === 'Enter') {
			this.search(e.target.value);
		}
	}
	search(search) {
		this.props.onSearch(search.trim());
	}
	render() {
		let { placeholder, value } = this.props;
		return (
			<div className="RockNavigatorSearchBar" >
				<div className="RockNavigatorSearchBarField" >
					<input type="text" onKeyUp={this.onSearchKey} placeholder={placeholder || "Search... "} defaultValue={value} />
				</div>
				<button onClick={e => this.props.onSearch(null)}>Cancel</button>
			</div>
		)
	}
}
export class ZooOptionMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	onClick(option, e) {
		e.preventDefault();
		this.setState({ open: false });
		this.props.onClick(option);
	}
	toggleOpen() {
		this.setState({ open: !this.state.open });
	}
	render() {
		let { options, label } = this.props;
		let { open } = this.state;
		return (
			<div className="ZooOptionMenu">
				<div className="ZooOptionMenuLabel" onClick={this.toggleOpen.bind(this)} >{label} <FontAwesomeIcon icon={faChevronDown} /></div>
				{ open ? 
					<div className="ZooOptionMenuDropDown">
					{ options.map( o => {
						return <MainMenuItem label={o} onClick={this.onClick.bind(this, o)} />
					} ) }
					</div>
				: '' }
			</div>
		)
	}
}
export class ZooServiceUI extends React.Component {
	constructor(props) {
		super(props);
		this.state = { playing: true }; // this.props.playing };
	}
	componentDidMount() {
		let { autoplay } = this.props;
		if (autoplay) {
			this.play();
		}
	}
	play() {
		this.props.play();
		this.setState({ playing: true });
	}
	render() {
		let { service } = this.props;
		let { playing  } = this.state;
		let apikey = ZProps.get("user").apikey;
		if (!playing || !apikey) {
			return (
				<div className="CENTERED ZooServiceUIPlayButton">
					<button tabIndex="0" aria-label="Play" onClick={this.play.bind(this)}><FontAwesomeIcon icon={faPlay} /></button>
					<h1>Start demonstration</h1>
				</div>
			)
		}
		let ui = service.nodes.find( x => x.kind === "ui" );
		let ui_type = ui.type.split(":")[0];
		let url = ui.url || (ZUtil.isDevelopment() ? "http://data.fab.ai.s3.amazonaws.com" : "https://data.automatic.ai") + "/html/" + ui_type + ".html?service_uri=" + encodeURIComponent(service.uri) + "&api_token=" +  encodeURIComponent(apikey) + "&refresh=" + service.updated_at;

		if (ZUtil.isDevelopment()) {
			url += "&debug=true";
		} else if (ZUtil.isStaging()) {
			url = url.replace(".automatic.", ".fab.");
		}
		return 	(
			<div className="ZooServiceUI">
				<iframe title="Service UI" frameBorder="0" src={url} marginWidth="0" marginHeight="0" vspace="0" hspace="0" border="0" scrolling="yes" ></iframe>
				{ !service.trained ? <div className="ZooServiceUIOverlay"><div className="CENTEREDPART">Not trained</div></div> : 
				!service.deployed ? <div className="ZooServiceUIOverlay"><div className="CENTEREDPART">Not deployed</div></div> : '' }
			</div>
		);
	}
}
export class ZooComponentUI extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
	}
	play() {
	}
	render() {
		let { item } = this.props;
		var thumb = AMC.getNodeThumb(item, true);
		let type = item.uri.split("/")[2];
		return (
			<div className="ZooComponentUI">
				<div className="ZooComponentUIThumbContainerBG">
					<div className="ZooComponentUIThumbContainer">
						{ typeof thumb === "string" ?
							<div className="ZooComponentUIThumb" style={{backgroundImage: "url(" + thumb + ")", backgroundSize: thumb.endsWith(".jpg") ? "cover" : "contain"}} title={item.kind + " " + item.name} ></div>
						:
							<div className="ZooComponentUIThumb" title={item.kind + " " + item.name} >{thumb}</div>
						}
					</div>
					<div className="ZooComponentUIKind">
						<span>{item.kind}</span>
					</div>
				</div>
				<div className="ZooComponentUIType">
					<span>{type}</span>
				</div>
			</div>
		)
	}
}
export class ZooEmbeddedSearchResults extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		let { item, kind } = this.props;
		if (kind === "partslist") {
			let nodes = AMC.getFlattenedService(item);
			nodes = ZUtil.uniqBy(nodes, "type");
			nodes = nodes.filter( n => n.kind !== "service" ).map( n => n.kind === "modelsource" ? n : ZProps.get(n.type) );
			this.setState({ items: nodes });
//		} else if (kind === "usedby") {
//			ZNetwork.get("search", "uses:" + item.uri, (err, list) => {
//				this.setState({ items: (list && list.services) || [] });
//			})
		} else { // "usedby"
			ZNetwork.get("search", "is:service " + (item.type ? item.type.split("/")[2] : item.uri), (err, list) => {
				this.setState({ items: (list && list.services) || [] });
			})
		}
	}

	render() {
		let items = this.state.items;
		if (!items) {
			return <PleaseStandBy />;
		}
		if (items.length === 0) {
			return <div className="ZooEmbeddedSearchResults"><ZooNoResultsFound /></div>
		}
		if (this.state.error) {
			return <ZooErrorFoundPage />;
		}
		let items_widgets = [];
		for (let i = 0; i < items.length; ++i) {
			items_widgets.push(<ZooSearchResultLineItem key={i} item={items[i]} rank={i + 1} />);
		}
		return (
			<div className="ZooEmbeddedSearchResults">{items_widgets}</div>
		)
	}
}
export class ZooDatasourceViewer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		let { item } = this.props;
		if (item.kind !== "datasource") {
			return this.setState({ error: "Can only peek at a datasource" });
		}
		let type = ZProps.get(item.type);
		ZNetwork.get("mvp", "preview", type.datasource, (err, data) => {
			this.setState({ error: err, data: data });
		})
	}
	render() {
		let { data } = this.state;
		if (this.state.error) {
			return <ZooErrorFoundPage />;
		}
		if (!data) {
			return <PleaseStandBy />;
		}
		if (data.length === 0) {
			return <ZooNothingFoundPage />;
		}
		let payload = data.replace(/ /g, "&nbsp;").replace(/\r/g,"").split("\n").map( l => "<div>" + l + "</div>" ).join("");
		return <div className="ZooDatasourceViewer" dangerouslySetInnerHTML={{__html: payload}}></div>
	}
}




export class ZooComputeUpgrades extends React.Component {
	constructor(props) {
		super(props);
		this.costs = { };
		let group = ZProps.get("usergroup");
		this.state = { total: 0, speed: group.compute, choices: { speed: group.compute } }; //, batterypack: usersettings.batterypack, supercharger: usersettings.supercharger } };
	}
	componentDidMount() {
		AMC.getPricingPlans((err, plans) => {
			if (!err) {
				this.setState({ plans: plans });
			} else {
				this.setState({ error: err });
			}
		});
	}
	onBatteryPackChoice(f) {
		this.update("batterypack", f.id, true);
	}
	update(what, id, checked) {
		let { choices, plans } = this.state;
		if (!checked) {
			delete choices[what];
		} else {
			choices[what] = id;
		}
		ZLog.debug("ZooComputeUpgrades.update - what=" +what + ", " + (plans.plans[choices[what]] && plans.plans[choices[what]].pricing));
		let total = Object.keys(choices).reduce( (sum, c) => sum + (plans.plans[choices[c]] ? plans.plans[choices[c]].pricing : 0) , 0);
		this.setState({ total: total, choices: choices });
	}
	onSuperCharger(f, e) {
		this.update("supercharger", f.id, e.target.checked);
	}
	onSpeedChange(id) {
		this.update("speed", id, true);
	}
	onMakeItSo = () => {
		let { caller } = this.props;
		let { choices } = this.state;
		let group = ZProps.get("usergroup");
		if (choices.speed && choices.speed !== group.compute) {
			group.compute = choices.speed;
			ZProps.set("usergroup", group);
			AMC.saveUser(group, null, (err) => {
				delete choices.speed;
				this.forceUpdate();
				caller.forceUpdate();
				APP.closePopups();
			})
		} else {
			this.forceUpdate();
			caller.forceUpdate();
			APP.closePopups();
		}
	}
	onOrderComplete = () => {
		this.forceUpdate();
		APP.closePopups();
	}
	render() {
		let { plans, total, choices } = this.state;
		if (!plans) {
			return <PleaseStandBy />;
		}
		let speed = (choices.speed || AMCConstants.DEFAULT_SPEED);
//		let supercharger = choices.supercharger;
//		let user = ZProps.get("user");
		let group = ZProps.get("usergroup");
		let capacity = (group.capacity || 1);
		let PLANS = plans;
		plans = PLANS.plans;
		let SPEEDS = AMCConstants.SPEEDS;
/*
			[
			// { name: "10", desc: "Infinity grade compute. The most kickass GPU we have access to. Perhaps the most expensive per job but it gets it done ASAP.", plans: ["pro", "enterprise", "premium"], id: 10 },
			{ name: "3", desc: "AWS Lambda 3Gb. Faster and perhaps more expensive per job but it gets it done quicker.", plans: ["pro", "enterprise", "premium"], id: 3 },
			{ name: "1", desc: "AWS Lambda 1Gb. Gets the job done and probably the best price per job if you are willing to wait.", id: 1 },
		];
*/

		let BATTERYPACKS = PLANS.batterypacks.map( p => {
			let plan = plans[p];
			return { name: plan.name, desc: "Add " + ZUtil.withCommas(plan.capacity) + " computes", price: ZUtil.toPrice(plan.pricing), id: plan.id }
		});
//			{ name: "Super battery pack", desc: "Kicks in whenever your plan runs out. Expires in one month. Some restrictions apply.", price: 99.95, id: "super" },
//			{ name: "Battery pack", desc: "Additional 2000 computes every month", price: ZUtil.toPrice(plans[PLANS.POWERPACK_PLAN_MONTHLY].pricing) + "/mo", id: "double" },
//			{ name: "Battery pack", desc: "Doubles whatever your plan offers.", price: ZUtil.toPrice(plans[PLANS.POWERPACK_PLAN_MONTHLY].pricing) + "/mo", id: "double" },
			// { name: "Recharge", desc: "Fill your capacity back up to what your plan offers.", price: ZUtil.toPrice(plans[PLANS.RECHARGE].pricing), id: "capacity" },
//		]
			
		let speeds = SPEEDS.map( (f, index) => <li key={f.name}><input key={"speed" + index} type="radio" name="speed" defaultChecked={speed === f.id} onChange={this.onSpeedChange.bind(this, f.id)} /> <strong>Factor {f.id}</strong> <span>{f.name}. {f.desc}</span></li> );


		let capacities = [{ name: "None", id: "None", price: 0 }].concat(BATTERYPACKS).map( (f, index) => <li key={f.name}><input type="radio" name="batterypacks" defaultChecked={f.name === "None"} onChange={this.onBatteryPackChoice.bind(this, f)} disabled={!AMC.isPremiumUser()} /> <strong>{f.name} (${f.price})</strong> <span>{f.desc}</span> </li> );

ZLog.debug("battery=" + Math.floor(Math.max(Math.min(capacity, 10), 0)/2.1));

		let BATTERIES = [faBatteryEmpty, faBatteryQuarter, faBatteryHalf, faBatteryThreeQuarters, faBatteryFull];
		let battery = BATTERIES[Math.floor(Math.max(Math.min(capacity, 10), 0)/2.1)];
		return (
			<div className="ZooComputeUpgrades" onClick={ZUtil.eatEvent}>
				<div className="ZooComputeUpgradesList">
					<h2> <FontAwesomeIcon icon={faBolt} /> Speed</h2>
					<ul>{speeds}</ul>
					{/* <h2><FontAwesomeIcon icon={faCheck} /> Superchargers</h2>
					<ul>{superchargers}</ul> */}
					<h2><FontAwesomeIcon icon={battery} /> Battery Packs *</h2>
					<ul>{capacities}</ul>
					<div className="ZooComputeUpgradesTotal">Total ${ZUtil.toPrice(total)}
					{ total ? 
						<div className="ZooComputeUpgradeButtons">
							<AMCStripeCheckoutButton label={"checkout"} products={Object.keys(choices).filter( k => k !== "speed" ).map(k => choices[k]).filter(p => p && p !== "None")} caller={this} />
						</div>
					:
						<div className="ZooComputeUpgradeButtons">
							<div className="ZooComputeUpgradesMakeItSo"><button onClick={this.onMakeItSo}>make it so</button></div>
						</div>
					}
					</div>
					{ group.plan !== "business" ?
						<div className="ZooComputeUpgradeMembership">Or take the opportunity now to <a href="/-/pricing" onClick={ e => { e.preventDefault(); ROUTER.pushRoute("/-/pricing"); } }>Upgrade your membership...</a></div> : '' }
					<div>* Computes are non-redeemable. Non-returnable. Non-transferable. One compute is enough for approximately one 200 epoch NMIST training. Additional computes can be purchased by ordering extra battery packs. Battery packs only available with Premium or better plans.</div>
				</div>
			</div>
		);
	}
}

		
export class RockAreYouSure extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { theyAreSure, msg } = this.props;
		return	(
			<div className="RockAreYouSure CENTERED">
				<div className="RockAreYouSureBox">
					<h1 className="ACAreYouSureMsg">{msg || "Are you sure about that?"}</h1>
					<button className="ACAreYouSureButtonYes ACButton" onClick={e => theyAreSure(true)}>yes</button>
					<button className="ACAreYouSureButtonNo ACButton" onClick={e => theyAreSure(false)}>no</button>
				</div>
			</div>
		);
	}
}

export class ZooMiniRockstar extends React.Component {
	constructor(props) {
		super(props);
		this.state = { expanded: this.props.expanded, selected_panel: "type" };
	}
	componentDidMount() {
		let { item } = this.props;
		if (ZUtil.getCandy("minirockstar")) {
			let cookie = JSON.parse(ZUtil.getCandy("minirockstar"));
			this.setState({ 
				selected_panel: cookie.selected_panel,
				rockstar_open: cookie.rockstar_open,
				workspace_open: cookie.workspace_open,
				inspector_open: cookie.inspector_open
			});
		}
		if (ZUtil.getCandy("rockstar")) {
			let cookie = JSON.parse(ZUtil.getCandy("rockstar"));
			this.setState({ 
				workspace_open: cookie.workspace_open
			});
		}
		this.transman = AMCTransactionsManagerFactory.manage(item);
		this.transman.setSaver(uri => { ZUtil.throttle(uri, () => this.save(uri), 1000) });
	}
	componentWillUnmount() {
	}
	save(item_uri, callback) {
		ZLog.debug("ZooMiniRockstar.save saved at " + Date.now());
		AMC.save(item_uri, (err) => {
			if (!err) {
				this.setState({ saved: Date.now() });
			}
			if (callback) {
				callback(err);
			}
		});
	}
	_updateCandies(state) {
		let s = {};
		s.selected_panel = this.state.selected_panel;
		s.rockstar_open = this.state.rockstar_open;
		s.workspace_open = this.state.workspace_open;
		s.inspector_open = this.state.inspector_open;
		s = Object.assign(s, state);
ZLog.log("_updateCandies", { s: s});
		ZUtil.setCandy("minirockstar", JSON.stringify(s));
	}
	areYouSure(msg, yes_function) {
		this.setState({ push_panel: this.state.selected_panel, selected_panel: "areyousure", areyousure: yes_function, areyousuremsg: msg });
	}
	theyAreSure(flag, event) {
		if (flag) {
			this.state.areyousure(event);
		}
		this.setState({ panel: this.state.push_panel, areyousure: null, areyousuremsg: null});
	}
	deleteItem(item_uri) {
		ZLog.debug("deleteItem" + item_uri);
		if (item_uri) {
			this.areYouSure("Are you sure you want to delete " + ZProps.get(item_uri).name + "?", () => {
				let id = this.transman.startTransaction("user deleted node");
				this.transman.destroyPart(item_uri);
				this.transman.endTransaction(id);
			});
		}
	}
	selectButton(item, force) {
		let panel = (this.state.selected_panel === item.kind && force !== true) ? null : item.kind;
		this._updateCandies({ selected_panel: panel, selected_button: panel ? item.uri : null });
		ZLog.debug("selectButton panel=" + panel);
		this.setState({ selected_panel: panel, selected_button: panel ? item.uri : null, selected_part: item.kind === "helpmechoose" ? this.state.selected_part : null });
	}
	selectItem(item) {
		if (item && typeof item === "string") {
			item = ZProps.get(item);
		}
		ZLog.debug("selectPart", { part: item });
		this.setState({ selected_part: item, selected_panel: this.state.selected_button ? "edit" : this.state.selected_panel, selected_button: null });
	}
	newPlaceholder(item) {
		ZLog.debug("newPlaceholder", { item: item });
		let placeholder = { kind: "placeholder", type: null, name: "placeholder", uri: "placeholder-" + Date.now() };
		ZProps.set(placeholder.uri, placeholder);
		this.graphman.insertNewPart(item.uri, placeholder.uri, false);
		this.forceUpdate();
	}
	showInspector = (flag, toggle) => {
		ZLog.debug("showInspector: " + flag);
		flag = (flag === undefined || toggle === true) ? !this.state.inspector_open : flag;
		let panel = typeof flag === "string" ? flag : null; // this.state.selected_panel;
		this.setState({ inspector_open: flag, selected_panel: panel });
		this._updateCandies({ inspector_open: !!flag, selected_panel: panel });
	}
	onSelectPanel = (panel) => {
		this.setState({ selected_panel: panel });
		this._updateCandies({ selected_panel: panel });
	}
	togglePanel = (which) => {
		if (!which) {
			return;
		}
		if (which === "expand") {
			this.props.toggleExpand();
		} else if (which === "rockstar") {
			this._updateCandies({ rockstar_open: !this.state.rockstar_open });
			this.setState({ rockstar_open: !this.state.rockstar_open });
		} else if (which === "workspace") {
			let to_open = !this.state.workspace_open;
			this.setState({ rockstar_open: to_open, workspace_open: to_open });
			this._updateCandies({ rockstar_open: to_open, workspace_open: to_open });
		} else {
			let panel = this.state.selected_panel === which ? null : which;
			this.setState({ selected_panel: panel, selected_button: null });
			this._updateCandies({ selected_panel: panel });
		}
	}
	assignTypeToRock = (item) => {
	}
	assignPropsToRock = (item) => {
	}
	render() {
		let { item, onWorkspaceItemSelect } = this.props;
		let { selected_panel, rockstar_open, saved, workspace_open, inspector_open } = this.state;
		let panelwidget;
		let target = item;
		let panel = selected_panel || (["wtf", "freakout", "helpmechoose", "rockpile"].indexOf(target.kind) !== -1 ? "source" : "type");
		let panel_manages_scrolling = {};
		let transman = this.transman;
		let modes = Object.assign({}, this.state);
		let workspace;
		if (!rockstar_open) {
			inspector_open = false;
		}

		ZLog.debug("mini panel=" + panel);
		ZLog.debug("mini saved=" + saved);
		ZLog.debug("mini target=" , { target: target });
		ZLog.debug("mini state=", {state: this.state});
		if (panel) {
			switch (panel) {
				case "source" :
					// panelwidget = <RockInspectorSourceCode key={target.uri} item={target} />;
					panel_manages_scrolling = { overflow: "hidden" };
					break;
				case "edit" :
				//	panelwidget = <RockInspectorPropertiesForm service={item} key={target.uri} node={target} readonly={!AMC.isEditable(target)} typetransman={transman} is_type={true} />
					break;
				case "areyousure" :
					//panelwidget = <RockAreYouSure theyAreSure={this.theyAreSure.bind(this)} msg={areyousuremsg} />
					break;
				default : 
					break;
			}
		}
		panelwidget = inspector_open ? <RockPanel key={item.uri + "-" + panel} ed={this} target_uri={item.uri} selected_panel={panel} service={null} transman={transman} nav_width={"100%"} onSelectPanel={this.onSelectPanel} onClosePanel={workspace_open ? () => this.showInspector(undefined, false) : null} assignPropsToRock={this.assignPropsToRock} assignTypeToRock={this.assignTypeToRock} is_mini={true} /> : '';
		if (workspace_open) {
			panel_manages_scrolling.left = "50%";
			workspace = <RockWorkspace onWorkspaceItemSelect={onWorkspaceItemSelect} toggleInspector={() => this.showInspector(undefined, true)} inspector_open={inspector_open} selected_item={item} view="settings" />
		}
		return (
			<div className="ZooRockstar ZooMiniRockstar">
					<div className="ZooPageProfileArea" >
						{ rockstar_open ? 
							<div>
								{workspace}
								{ panelwidget ?
								<div className="ZooPageProfilePanelArea" style={panel_manages_scrolling} >
									{ panelwidget }
								</div>
								: '' }
							</div>
						: 
							<div className="ZooPageProfileFeature">
								<ZooComponentUI item={target} />
							</div>
						}
					</div>
					<ZooRockstarControls item={item} rockstar_open={rockstar_open} panel={panel} togglePanel={this.togglePanel} modes={modes} saved={saved}  />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/ZooProfilePage.js